import { Transitions } from '@/ui/theme/types';

export const transitions: Transitions = {
  normal: 200,
};
